<template>
  <b-modal ref="modal" :title="form.id ? 'Edit Client Notification' : 'Create Client Notification'" lazy>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>

      <v-form-group :validator="$v.form.clientId" label="Client">
        <v-select slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                  id="role"
                  :class="[{ 'vs--has-value': form.clientId }]"
                  v-model="form.clientId"
                  :options="clientOptions"
                  :clearable="false"
                  :filterable="false"
                  :searchable="false"
                  placeholder="Client" />
      </v-form-group>
      <v-form-group :validator="$v.form.email" label="Email">
        <b-form-input v-model="form.email" placeholder="Email" />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">{{ form.id ? 'Edit': 'Create' }}</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators';

  import clientService from 'services/client-service';
  import clientNotificationService from 'services/client-notification-service';

  import modalFormMixin from 'mixins/modal-form-mixin';

  export default {
    mixins: [modalFormMixin],

    data() {
      return {
        form: {
          id: 0,
          clientId: 0,
          email: ""
        },

        clientOptions: [],
      }
    },

    validations() {
      return {
        form: {
          clientId: {
            required
          },
          email: {
            required,
            email
          },
        }
      }
    },

    methods: {
      async beforeShow(id) {
        const clients = await clientService.getForFilter();

        this.clientOptions = clients.map(c => {
          return {
            text: c.text,
            label: c.text,
            value: c.value
          }
        }).sort((a, b) => a.label.localeCompare(b.label));

        if (id) {
          this.form = await clientNotificationService.getForForm(id);
          this.form.clientId = this.clientOptions.find(opt => opt.value == this.form.clientId);
        }
      },

      async onSubmit() {
        await clientNotificationService.save({
          id: this.form.id,
          clientId: this.form.clientId.value,
          email: this.form.email
        });
      },
    },
  }

</script>